import React, { useState } from 'react';
import first_icon from '../../assets/images/first_icon.png';
import second_icon from '../../assets/images/second_icon.png';
import third_icon from '../../assets/images/third_icon.png';
import fourth_icon from '../../assets/images/third_icon.png';
import '../../assets/css/OurQuality.css';
// import { useDispatch, useSelector } from 'react-redux';

const OurQuality = () => {

    // const dispatch = useDispatch();
    // const reduxState = useSelector((state) => state);

    return (
        <div className=''>
            {/* <button
                onClick={() => {
                    showLoader("flex");
                    dispatch({
                        type: "INC"
                    })
                }}
                className='btn btn-primary'>Redux dispatch Button</button> */}
            <div className='row'>
                <div className='col-lg-12 text-center' >
                    <p className='text-white f-mon-reg f-30 mb-0'>Why Prediction Dog</p>
                    <p className='text-white f-mon-bold f-50 lh-01'>WHAT MAKES US <span className='clr-e0'>“Big Dog”</span></p>
                    <div className='border-btm-pink-secondsec'></div>
                    <p className='text-white f-20 f-mon-light mt-3 wdth-80-per'>Years of experience, dedication, drive, and commitment to working hard to get results to make a profit. We are at it every day, finding the information we need to be on the right-side. We make you successful sports bettors.</p>
                </div>
                <div className='col-lg-12'>
                    <div className='icons_second_sec'>
                        <div className='text-center'>
                            <img src={first_icon} alt="icon second sec" />
                            <p className='text-white mt-3 bet-txt'>Line Moves</p>
                        </div>
                        <div className='text-center'>
                            <img src={second_icon} alt="icon second sec" />
                            <p className='text-white mt-3 bet-txt'>Injury Updates</p>
                        </div>
                        <div className='text-center'>
                            <img src={third_icon} alt="icon second sec" />
                            <p className='text-white mt-3 bet-txt' >Trends</p>
                        </div>
                        <div className='text-center'>
                            <img src={fourth_icon} alt="icon second sec" />
                            <p className='text-white mt-3 bet-txt'>Made over 20,000 <br/> successful wagers</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
};

export default OurQuality;